export default class DateRange {
  start?: Date;

  end?: Date;
}
